<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <div class="row">
    <h4 class="col">Cálculo do Encargo de Concessão de Garantia</h4>
    <div class="col-auto" *ngIf="permissaoEnvio">
      <button class="btn btn-light" (click)="limpar()">Limpar</button>
      <button type="button" class="btn btn-secondary ms-2" (click)="carregar()" [disabled]="!podeCarregar">Carregar</button>
      <button class="btn btn-primary" (click)="calcular()" [disabled]="!formCalculoECG.valid">Calcular ECG</button>
    </div>
  </div>
  <form [formGroup]="formCalculoECG">
    <div class="row">
      <div class="col-md-3 bn-form-group"> 
        <label class="form-label"><b>Id. operação crédito</b></label>
        <input type="text" class="form-control" formControlName="idOperacaoCredito" bnMask="INTEIRO" (keydown.tab)="buscarOperacao()">
      </div>
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>Id. Liberação</b></label>
        <input type="text" class="form-control" formControlName="idLiberacao" bnMask="INTEIRO" (keydown.tab)="buscarLiberacao()"> 
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>Valor em Reais</b></label>
        <input type="text" class="form-control" bnMask="MOEDA" formControlName="valor">
      </div>
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>Fator K</b></label>
        <input type="text" class="form-control" bnMask="DECIMAL" [casasDecimais]="4" formControlName="fatorEncargo">
      </div>
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>Tranche <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="A tranche é utilizada para consulta da tabela de fatores redutores de ECG vigente."></i></b></label>
        <select class="form-select" formControlName="numeroTranche">
          <option value=""></option>
          <option [value]="tranche" *ngFor="let tranche of numerosTranches">{{ tranche }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">     
        <label class="form-label"><b>Percent. garantido <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Percentual garantido da operação"></i></b></label>
        <select class="form-select" formControlName="percentualGarantidoDecimal" required >
          <option [value]="percentualPorModalidade" *ngFor="let percentualPorModalidade of percentuaisPorModalidade">{{percentualPorModalidade | bnMask:'INTEIRO'}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-3"> 
        <label class="form-label"><b>Data de Início do Cálculo</b></label>
        <bn-datepicker formControlName="inicio">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3"> 
        <label class="form-label"><b>Data de Fim do Cálculo</b></label>
        <bn-datepicker [minDate]="dataFuturaUltimaAmortizacao" formControlName="dataUltimaAmortizacao">
        </bn-datepicker>
      </div>
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>ECG somado ao saldo</b></label>
        <input type="checkbox" class="form-check checkbox-gigante" formControlName="encargoEhGarantido">
      </div>
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>Pessoa com Deficiência</b></label>
        <input type="checkbox" class="form-check checkbox-gigante" formControlName="consideraDescontoPcd">
      </div>
    </div>
  </form>
  <form [formGroup]="formCalculoECGRetorno">
    <div class="mt-4" *ngIf="mostrarResultado">
      <div class="row">
        <h4 class="col">Resultado do cálculo</h4>
      </div>
      <div class="row">
        <div class="col-md-3 bn-form-group">
          <label class="form-label"><b>Valor do ECG</b></label>
          <input type="text" class="form-control" bnMask="MOEDA" formControlName="valorEcg" readonly>
        </div>
        <div class="col-md-3 bn-form-group">
          <label class="form-label"><b>% desconto ECG</b></label>
          <input type="text" class="form-control" bnMask="DECIMAL" casasDecimais="4" formControlName="fatorRedutorECG" readonly>
        </div>
        <div class="col-md-3 bn-form-group">
          <label class="form-label">
            <b>Quantidade de meses</b>
            <i class="fa fa-question-circle help-subtitulo" placement="bottom" 
            ngbTooltip="Número de períodos completos de 30 dias entre as datas de inicio e fim"></i>
          </label>
          <input type="text" class="form-control" formControlName="quantidadeMeses" readonly>
        </div>
        <div class="col-md-3 bn-form-group">
          <label class="form-label">
            <b>Quantidade de Dias</b>
            <i class="fa fa-question-circle help-subtitulo" placement="bottom" 
            ngbTooltip="Número de dias corridos entre as datas de início e fim"></i>
          </label>
          <input type="text" class="form-control" formControlName="quantidadeDias" readonly>
        </div>
      </div>
    </div>
  </form>
</div>